import { useEffect, useState } from 'react';
import { SaveOutlined, UploadOutlined, DownloadOutlined, PlusOutlined, DeleteOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Space, Table, Tag, Upload, Select, Card, Popconfirm } from 'antd';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { responseStatus, urlAdmin } from "../../constants";
import { validateMessages } from "../../helpers/common";
import { ApiPaths } from "../../helpers/api";
import intance from "../../utils/axios";
import { DotKiemKeTaiSan, DotKiemKeTaiSanRequest, DotKiemKe_ThanhVien, TrangThaiDotKiemKe } from "../../models/taisan/DotKiemKeTaiSan";
import { luuDotKiemKe } from "../../services/dotKiemKeTaiSan";
import { layPhoCVPDuyetTongHopDaoTao, layPhoGiamDocDuyetTongHopDaoTao, layChanhVPDuyetTongHopDaoTao, layGiamDocDuyetTongHopDaoTao } from "../../services/daotao";
import { useSelector } from 'react-redux';
import NhanVienSelectBox from "../utils/NhanVienSelectBox";

const { TextArea } = Input;

const LuuDotKiemKeBox = ({ modelProps, onSubmit }: {
    modelProps: DotKiemKeTaiSan | null,
    onSubmit: () => void
}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [form] = Form.useForm();
    
    const [dsThanhVien, setDsThanhVien] = useState<DotKiemKe_ThanhVien[]>([]);
    const [dsNhanVienFull, setDsNhanVienFull] = useState<any[]>([]);
    
    const [phoCVP, setPhoCVP] = useState<any>(null);
    const [isTrinhPhoCVP, setIsTrinhPhoCVP] = useState(false);
    const [phoGD, setPhoGD] = useState<any>(null);
    const [isTrinhPhoGD, setIsTrinhPhoGD] = useState(false);
    const [chanhVP, setChanhVP] = useState<any>(null);
    const [isTrinhCVP, setIsTrinhCVP] = useState(false);
    const [giamDoc, setGiamDoc] = useState<any>(null);
    const [isTrinhGD, setIsTrinhGD] = useState(false);
    
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [isXoaFile, setIsXoaFile] = useState(false);

    const user = useSelector((state: any) => state.auth.currentUser);
    const isThemMoi = !modelProps?.id;
    const isCreator = isThemMoi || modelProps?.idNVKhoiTao === user?.id;
    const isEditableTrangThai = [
        TrangThaiDotKiemKe.KhoiTao,
        TrangThaiDotKiemKe.ThuHoi,
        TrangThaiDotKiemKe.PhoCVPTraLai,
        TrangThaiDotKiemKe.CVPTraLai,
        TrangThaiDotKiemKe.PhoGiamDocTraLai,
        TrangThaiDotKiemKe.GiamDocTraLai,
    ];
    const isReadOnly = !isCreator || (modelProps != null && !isEditableTrangThai.includes(modelProps.trangThai));

    const getTrangThaiInfo = (value?: number) => {
        switch (value) {
            case TrangThaiDotKiemKe.KhoiTao:
                return { label: 'Khởi tạo', color: 'default' };
            case TrangThaiDotKiemKe.ThuHoi:
                return { label: 'Thu hồi', color: 'red' };
            case TrangThaiDotKiemKe.TrinhPhoCVP:
                return { label: 'Trình Phó CVP', color: 'blue' };
            case TrangThaiDotKiemKe.TrinhCVP:
                return { label: 'Trình CVP', color: 'blue' };
            case TrangThaiDotKiemKe.TrinhPhoGiamDoc:
                return { label: 'Trình Phó Giám đốc', color: 'blue' };
            case TrangThaiDotKiemKe.TrinhGiamDoc:
                return { label: 'Trình Giám đốc', color: 'blue' };
            case TrangThaiDotKiemKe.PhoCVPTraLai:
                return { label: 'Phó CVP trả lại', color: 'orange' };
            case TrangThaiDotKiemKe.CVPTraLai:
                return { label: 'CVP trả lại', color: 'orange' };
            case TrangThaiDotKiemKe.PhoGiamDocTraLai:
                return { label: 'Phó Giám đốc trả lại', color: 'orange' };
            case TrangThaiDotKiemKe.GiamDocTraLai:
                return { label: 'Giám đốc trả lại', color: 'orange' };
            case TrangThaiDotKiemKe.PheDuyet:
                return { label: 'Đã phê duyệt', color: 'green' };
            case TrangThaiDotKiemKe.DangKiemKe:
                return { label: 'Đang kiểm kê', color: 'cyan' };
            case TrangThaiDotKiemKe.HoanThanh:
                return { label: 'Hoàn thành', color: 'purple' };
            case TrangThaiDotKiemKe.DaDong:
                return { label: 'Đã đóng', color: 'magenta' };
            default:
                return { label: 'Không xác định', color: 'default' };
        }
    };

    const setFormDetailModal = (value: DotKiemKeTaiSan | null) => {
        form.setFieldsValue({
            id: value?.id,
            maDotKiemKe: value?.maDotKiemKe,
            tenDotKiemKe: value?.tenDotKiemKe,
            idsDSNguoiPhuTrach: value?.idsDSNguoiPhuTrach || [],
            ngayBatDau: value?.ngayBatDau ? dayjs(value.ngayBatDau) : null,
            ngayKetThuc: value?.ngayKetThuc ? dayjs(value.ngayKetThuc) : null,
            trangThai: value?.trangThai ?? TrangThaiDotKiemKe.KhoiTao,
            moTa: value?.moTa,
        });
        
        if (value?.fileDinhKemToKiemKe) {
            setFileList([{
                uid: '-1',
                name: value.fileDinhKemToKiemKe.split('\\').pop() || value.fileDinhKemToKiemKe.split('/').pop() || 'FileDinhKemToKiemKe.pdf',
                status: 'done',
                url: urlAdmin + value.fileDinhKemToKiemKe.replace(/\\/g, "/")
            }]);
        } else {
            setFileList([]);
        }
        setIsXoaFile(false);
        
        if (value) {
            if (value.dsThanhVien && value.dsThanhVien.length > 0) {
                setDsThanhVien(value.dsThanhVien);
            } else {
                setDsThanhVien([]);
            }

            if (value.idPhoCVP && value.idPhoCVP > 0) {
                setIsTrinhPhoCVP(true);
                setPhoCVP({ id: value.idPhoCVP, hoTen: value.tenPhoCVP });
            } else layDuLieuPhoCVP();
            
            if (value.idPhoGiamDoc && value.idPhoGiamDoc > 0) {
                setIsTrinhPhoGD(true);
                setPhoGD({ id: value.idPhoGiamDoc, hoTen: value.tenPhoGiamDoc });
            } else layDuLieuPhoGiamDoc();
            
            if (value.idChanhVP && value.idChanhVP > 0) {
                setIsTrinhCVP(true);
                setChanhVP({ id: value.idChanhVP, hoTen: value.tenChanhVP });
            } else layDuLieuChanhVP();
            
            if (value.idGiamDoc && value.idGiamDoc > 0) {
                setIsTrinhGD(true);
                setGiamDoc({ id: value.idGiamDoc, hoTen: value.tenGiamDoc });
            } else layDuLieuGiamDoc();
        } else {
            setDsThanhVien([]);
            layDuLieuPhoCVP();
            layDuLieuPhoGiamDoc();
            layDuLieuChanhVP();
            layDuLieuGiamDoc();
        }
    };

    const layDuLieuNhanVienFull = async () => {
        try {
            const res = await intance.get(ApiPaths.nhanVien.layDSToanBoNhanVien + "?showAll=1");
            if (res.data.trangThai === responseStatus.thanhCong) {
                setDsNhanVienFull(res.data.duLieu || []);
            }
        } catch (error) { }
    };

    const handleThemThanhVien = () => {
        const defaultRole = dsThanhVien.length === 0 ? 'Tổ trưởng' : (dsThanhVien.length === 1 ? 'Tổ phó' : 'Thành viên');
        setDsThanhVien([
            ...dsThanhVien,
            {
                idDotKiemKe: modelProps?.id,
                idNhanVien: undefined,
                hoTen: '',
                tenChucVu: '',
                vaiTro: defaultRole,
                thuTu: dsThanhVien.length + 1
            }
        ]);
    };

    const handleXoaThanhVien = (index: number) => {
        setDsThanhVien(dsThanhVien.filter((_, idx) => idx !== index));
    };

    const handleNhanVienChange = (index: number, idNhanVien: number) => {
        const nv = dsNhanVienFull.find(x => x.id === idNhanVien);
        const updated = [...dsThanhVien];
        updated[index] = {
            ...updated[index],
            idNhanVien: idNhanVien,
            hoTen: nv ? (nv.hoTen || nv.ten || '') : updated[index].hoTen,
            tenChucVu: nv ? (nv.tenChucVu || '') : updated[index].tenChucVu
        };
        setDsThanhVien(updated);
    };

    const handleFieldChange = (index: number, field: keyof DotKiemKe_ThanhVien, value: any) => {
        const updated = [...dsThanhVien];
        updated[index] = {
            ...updated[index],
            [field]: value
        };
        setDsThanhVien(updated);
    };

    const layDuLieuPhoCVP = async () => {
        try {
            let rs = await layPhoCVPDuyetTongHopDaoTao();
            setPhoCVP(rs);
        } catch (error: any) { }
    }
    const layDuLieuPhoGiamDoc = async () => {
        try {
            let rs = await layPhoGiamDocDuyetTongHopDaoTao();
            setPhoGD(rs);
        } catch (error: any) { }
    }
    const layDuLieuChanhVP = async () => {
        try {
            let rs = await layChanhVPDuyetTongHopDaoTao();
            setChanhVP(rs);
        } catch (error: any) { }
    }
    const layDuLieuGiamDoc = async () => {
        try {
            let rs = await layGiamDocDuyetTongHopDaoTao();
            setGiamDoc(rs);
        } catch (error: any) { }
    }

    const uploadProps: UploadProps = {
        onRemove: (file) => {
            setFileList([]);
            setIsXoaFile(true);
        },
        beforeUpload: (file) => {
            const isPdf = file.type === 'application/pdf';
            if (!isPdf) {
                toast.error('Chỉ hỗ trợ định dạng PDF!');
                return Upload.LIST_IGNORE;
            }
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                toast.error('File không được lớn hơn 20MB!');
                return Upload.LIST_IGNORE;
            }
            setFileList([file]);
            setIsXoaFile(false);
            return false;
        },
        fileList,
        maxCount: 1,
    };

    const onFinish = async (values: any) => {
        if (dsThanhVien.some(x => !x.hoTen || !x.hoTen.trim())) {
            toast.warning("Vui lòng nhập đầy đủ Họ và tên cho các thành viên trong Ban kiểm kê");
            return;
        }

        setIsLoading(true);

        var ngayBatDau = values.ngayBatDau ? dayjs(values.ngayBatDau).format("YYYY-MM-DD") : "";
        var ngayKetThuc = values.ngayKetThuc ? dayjs(values.ngayKetThuc).format("YYYY-MM-DD") : "";

        const memberEmployeeIds = dsThanhVien
            .map(x => x.idNhanVien)
            .filter((id): id is number => typeof id === 'number' && id > 0);

        const finalIdsPhuTrach = (values.idsDSNguoiPhuTrach && values.idsDSNguoiPhuTrach.length > 0)
            ? values.idsDSNguoiPhuTrach
            : memberEmployeeIds;

        var request: DotKiemKeTaiSanRequest = {
            id: modelProps?.id || undefined,
            maDotKiemKe: values.maDotKiemKe,
            tenDotKiemKe: values.tenDotKiemKe,
            ngayBatDau: ngayBatDau,
            ngayKetThuc: ngayKetThuc,
            trangThai: values.trangThai ?? TrangThaiDotKiemKe.KhoiTao,
            moTa: values.moTa,
            idsDSNguoiPhuTrach: finalIdsPhuTrach,
            idPhoCVP: isTrinhPhoCVP ? phoCVP?.id : 0,
            idPhoGiamDoc: isTrinhPhoGD ? phoGD?.id : 0,
            idChanhVP: isTrinhCVP ? chanhVP?.id : 0,
            idGiamDoc: isTrinhGD ? giamDoc?.id : 0,
            jsonDsThanhVien: JSON.stringify(dsThanhVien)
        };

        let file: File | null = null;
        if (fileList.length > 0 && fileList[0].originFileObj) {
            file = fileList[0].originFileObj as File;
        } else if (fileList.length > 0 && !fileList[0].url) {
            file = fileList[0] as unknown as File;
        }

        try {
            const response = await luuDotKiemKe(request, file, isXoaFile);
            if (response.trangThai === responseStatus.thanhCong) {
                toast.success(isThemMoi ? "Thêm mới đợt kiểm kê thành công" : "Cập nhật đợt kiểm kê thành công");
                onSubmit();
            } else {
                toast.error(response.thongBao);
            }
        } catch (error: any) {
            toast.error('Lỗi: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        layDuLieuNhanVienFull();
    }, []);

    useEffect(() => {
        setFormDetailModal(modelProps);
    }, [modelProps]);

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            validateMessages={validateMessages}
        >
            <Form.Item name="trangThai" hidden>
                <Input />
            </Form.Item>
            <Row gutter={16}>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="maDotKiemKe"
                        label="Mã đợt kiểm kê"
                        rules={[{ required: true, message: 'Vui lòng nhập mã đợt kiểm kê' }]}
                    >
                        <Input placeholder="Nhập mã đợt kiểm kê" disabled={isReadOnly} />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={12}>
                    <Form.Item
                        name="tenDotKiemKe"
                        label="Tên đợt kiểm kê"
                        rules={[{ required: true, message: 'Vui lòng nhập tên đợt kiểm kê' }]}
                    >
                        <Input placeholder="Nhập tên đợt kiểm kê" disabled={isReadOnly} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col className="gutter-row" span={8}>
                    <Form.Item
                        name="ngayBatDau"
                        label="Ngày bắt đầu"
                        rules={[{ required: true, message: 'Vui lòng chọn ngày bắt đầu' }]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            format="DD/MM/YYYY"
                            placeholder="Chọn ngày bắt đầu"
                            disabled={isReadOnly}
                        />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                    <Form.Item
                        name="ngayKetThuc"
                        label="Ngày kết thúc"
                        rules={[{ required: true, message: 'Vui lòng chọn ngày kết thúc' }]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            format="DD/MM/YYYY"
                            placeholder="Chọn ngày kết thúc"
                            disabled={isReadOnly}
                        />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                    <Form.Item label="Trạng thái">
                        <Tag color={getTrangThaiInfo(modelProps?.trangThai ?? TrangThaiDotKiemKe.KhoiTao).color}>
                            {getTrangThaiInfo(modelProps?.trangThai ?? TrangThaiDotKiemKe.KhoiTao).label}
                        </Tag>
                    </Form.Item>
                </Col>
            </Row>

            {/* Quản lý Ban kiểm kê (Tổ kiểm kê) */}
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={24}>
                    <Card
                        size="small"
                        title={
                            <Space>
                                <UsergroupAddOutlined style={{ color: '#1890ff' }} />
                                <strong>Ban kiểm kê (Tổ kiểm kê)</strong>
                            </Space>
                        }
                        extra={!isReadOnly && (
                            <Button type="primary" size="small" icon={<PlusOutlined />} onClick={handleThemThanhVien}>
                                Thêm thành viên
                            </Button>
                        )}
                        style={{ border: '1px solid #d9d9d9', borderRadius: 6 }}
                    >
                        <Table
                            dataSource={dsThanhVien}
                            rowKey={(record, index) => `${record.id || index}`}
                            pagination={false}
                            size="small"
                            columns={[
                                {
                                    title: 'STT',
                                    width: 50,
                                    align: 'center',
                                    render: (_: any, __: any, idx: number) => idx + 1
                                },
                                {
                                    title: 'Chọn nhân viên',
                                    width: 230,
                                    render: (_: any, record: DotKiemKe_ThanhVien, idx: number) => (
                                        <Select
                                            showSearch
                                            allowClear
                                            style={{ width: '100%' }}
                                            placeholder="-- Chọn nhân viên --"
                                            value={record.idNhanVien || undefined}
                                            disabled={isReadOnly}
                                            filterOption={(input, option) =>
                                                (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={dsNhanVienFull.map(nv => ({
                                                value: nv.id,
                                                label: `${nv.hoTen || nv.ten}${nv.tenChucVu ? ` (${nv.tenChucVu})` : ''}`
                                            }))}
                                            onChange={(val) => handleNhanVienChange(idx, val)}
                                        />
                                    )
                                },
                                {
                                    title: 'Họ và tên',
                                    width: 180,
                                    render: (_: any, record: DotKiemKe_ThanhVien, idx: number) => (
                                        <Input
                                            placeholder="Họ và tên"
                                            value={record.hoTen}
                                            disabled={isReadOnly}
                                            onChange={(e) => handleFieldChange(idx, 'hoTen', e.target.value)}
                                        />
                                    )
                                },
                                {
                                    title: 'Chức vụ',
                                    width: 180,
                                    render: (_: any, record: DotKiemKe_ThanhVien, idx: number) => (
                                        <Input
                                            placeholder="Chức vụ"
                                            value={record.tenChucVu}
                                            disabled={isReadOnly}
                                            onChange={(e) => handleFieldChange(idx, 'tenChucVu', e.target.value)}
                                        />
                                    )
                                },
                                {
                                    title: 'Vai trò trong Tổ kiểm kê',
                                    width: 170,
                                    render: (_: any, record: DotKiemKe_ThanhVien, idx: number) => (
                                        <Select
                                            style={{ width: '100%' }}
                                            value={record.vaiTro}
                                            disabled={isReadOnly}
                                            onChange={(val) => handleFieldChange(idx, 'vaiTro', val)}
                                            options={[
                                                { value: 'Tổ trưởng', label: 'Tổ trưởng' },
                                                { value: 'Tổ phó', label: 'Tổ phó' },
                                                { value: 'Thành viên', label: 'Thành viên' },
                                                { value: 'Thư ký', label: 'Thư ký' },
                                                { value: 'Đại diện Đơn vị sử dụng', label: 'Đại diện Đơn vị sử dụng' },
                                            ]}
                                        />
                                    )
                                },
                                {
                                    title: 'Thao tác',
                                    width: 60,
                                    align: 'center',
                                    render: (_: any, __: any, idx: number) => (
                                        !isReadOnly ? (
                                            <Popconfirm title="Xác nhận xóa thành viên này?" onConfirm={() => handleXoaThanhVien(idx)}>
                                                <Button danger size="small" type="text" icon={<DeleteOutlined />} />
                                            </Popconfirm>
                                        ) : null
                                    )
                                }
                            ]}
                            locale={{ emptyText: 'Chưa có thành viên nào trong Ban kiểm kê. Bấm "+ Thêm thành viên" để thêm.' }}
                        />
                        <div style={{ marginTop: 8, fontSize: '12px', color: '#888' }}>
                            * Các thành viên trong Ban kiểm kê sẽ được xuất tự động vào Biên bản kiểm kê & Bảng tổng hợp Excel, đồng thời được phân quyền thực hiện kiểm kê.
                        </div>
                    </Card>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col className="gutter-row" span={24}>
                    <Form.Item name="moTa" label="Mô tả">
                        <TextArea
                            rows={4}
                            placeholder="Nhập mô tả về đợt kiểm kê"
                            disabled={isReadOnly}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col className="gutter-row" span={24}>
                    <Form.Item label="Đính kèm Quyết định thành lập tổ kiểm kê (PDF)">
                        <Upload {...uploadProps} disabled={isReadOnly}>
                            {!isReadOnly && <Button icon={<UploadOutlined />}>Chọn file</Button>}
                        </Upload>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={24} style={{ marginBottom: "10px" }}>
                    <Space direction="vertical">
                        <Checkbox
                            disabled={isReadOnly}
                            checked={isTrinhPhoCVP}
                            onChange={(e) => {
                                if (e.target.checked && phoCVP == null) {
                                    toast.warning("Vui lòng phân chức năng duyệt cho Phó CVP");
                                    return;
                                }
                                setIsTrinhPhoCVP(e.target.checked)
                            }}
                        >
                            Trình Phó Chánh Văn Phòng {phoCVP ? `(${phoCVP.hoTen})` : null}
                        </Checkbox>

                        <Checkbox
                            disabled={isReadOnly}
                            checked={isTrinhCVP}
                            onChange={(e) => {
                                if (e.target.checked && chanhVP == null) {
                                    toast.warning("Vui lòng phân chức năng duyệt cho Chánh VP");
                                    return;
                                }
                                setIsTrinhCVP(e.target.checked)
                            }}
                        >
                            Trình Chánh Văn Phòng {chanhVP ? `(${chanhVP.hoTen})` : null}
                        </Checkbox>

                        <Checkbox
                            disabled={isReadOnly}
                            checked={isTrinhPhoGD}
                            onChange={(e) => {
                                if (e.target.checked && phoGD == null) {
                                    toast.warning("Vui lòng phân chức năng duyệt cho Phó GĐ");
                                    return;
                                }
                                setIsTrinhPhoGD(e.target.checked);
                            }}
                        >
                            Trình Phó Giám đốc phụ trách Văn Phòng {phoGD ? `(${phoGD.hoTen})` : null}
                        </Checkbox>

                        <Checkbox
                            disabled={isReadOnly}
                            checked={isTrinhGD}
                            onChange={(e) => {
                                if (e.target.checked && giamDoc == null) {
                                    toast.warning("Vui lòng phân chức năng duyệt cho Giám đốc");
                                    return;
                                }
                                setIsTrinhGD(e.target.checked)
                            }}
                        >
                            Trình Giám đốc đơn vị {giamDoc ? `(${giamDoc.hoTen})` : null}
                        </Checkbox>
                    </Space>
                </Col>
            </Row>

            <Row>
                <Col span={24} style={{ textAlign: 'right' }}>
                    {isCreator && (
                        <Button type="primary" htmlType="submit" className="float-right" disabled={isLoading} icon={<SaveOutlined />}>
                            Lưu
                        </Button>
                    )}
                </Col>
            </Row>
        </Form>
    );
};

export default LuuDotKiemKeBox;
